import * as React from "react";
import { styled } from "@mui/material/styles";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import { Box, Stack, Grid } from "@mui/material";
import { appIcons } from "../../assets";
import ImageSwipper from "./../productDetail/ImageGallery";
import GlobalButton from "../button";

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: 6,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&::before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={
      <ArrowForwardIosSharpIcon
        sx={{ fontSize: "1.35rem", color: "text.black" }}
      />
    }
    {...props}
  />
))(({ theme }) => ({
  backgroundColor: "rgba(0, 0, 0, .03)",
  flexDirection: "row-reverse",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
    alignItems: "center",
  },
  ...theme.applyStyles("dark", {
    backgroundColor: "rgba(255, 255, 255, .05)",
  }),
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

export default function CustomizedAccordions({ data, index, mainIndex }) {
  const [expanded, setExpanded] = React.useState("panel0"); // Set first panel to be open by default

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false); // Only one accordion remains expanded
  };

  return (
    <div>
      <Accordion
        expanded={expanded === `panel${mainIndex}-${index}`}
        onChange={handleChange(`panel${mainIndex}-${index}`)}
      >
        <AccordionSummary
          aria-controls={`panel${mainIndex}-${index}-content`}
          id={`panel${mainIndex}-${index}-header`}
        >
          <Stack flexGrow={1}>
            <Typography variant="body1" fontWeight={500}>
              {data?.name}
            </Typography>
            <Typography
              variant="body2"
              sx={{
                overflow: "hidden",
                display: "-webkit-box",
                WebkitBoxOrient: "vertical",
                WebkitLineClamp: 1,
              }}
            >
              {data?.description}
            </Typography>
          </Stack>
          <Stack
            flexShrink={0}
            direction={"row"}
            alignItems={"center"}
            spacing={2}
          >
            <Box>
              <Typography variant="body1" fontWeight={600}>
                {data?.price} USD
              </Typography>
              <Typography fontSize={"0.75rem"}>Per Hour</Typography>
            </Box>
            <Box>
              <img src={appIcons.checkOrangeRedIcon} width={30} />
            </Box>
          </Stack>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container>
            <Grid item xs={12} md={7}>
              <ImageSwipper />
            </Grid>
            <Grid item xs={12} md={5}>
              <Stack gap={1}>
                <Typography variant="body1" fontWeight={500}>
                  Service : {data?.name}
                </Typography>
                <Typography variant="body1" fontWeight={500}>
                  Price : {data?.price} USD
                </Typography>
                <Box>
                  <Typography variant="body1" fontWeight={600}>
                    Description
                  </Typography>
                  <Typography>{data.description}</Typography>
                </Box>
              </Stack>
              <GlobalButton
                btnText={"Book"}
                styleProps={{
                  my: 2,
                  width: 120,
                }}
              />
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
